import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

const SectionColumnsNews = loadable(() =>
  import(/* webpackChunkName: "CMSPage" */ './SectionColumnsNews')
);

const SectionArticleBlog = loadable(() =>
  import(/* webpackChunkName: "CMSPage" */ './SectionArticleBlog')
);

export const CMSPageComponent = props => {
  const { params, pageAssetsData, inProgress, error, blogArticlesData, blogArticleIds } = props;
  const pageId = params.pageId || props.pageId;

  if (!inProgress && error?.status === 404) {
    return <NotFoundPage staticContext={props.staticContext} />;
  }

  // Identify page types
  const isNewsPage = pageId === 'news';
  const isBlogArticle = pageId?.startsWith('blog-');

  // Apply custom section components based on page type
  let customOptions;

  if (isNewsPage) {
    customOptions = {
      sectionComponents: {
        columns: { component: SectionColumnsNews },
      },
      // Pass blog articles data to be used by SectionColumnsNews
      blogArticlesData,
      blogArticleIds,
    };
  } else if (isBlogArticle) {
    customOptions = {
      sectionComponents: {
        article: { component: SectionArticleBlog },
      },
    };
  }

  return (
    <PageBuilder
      pageAssetsData={pageAssetsData?.[pageId]?.data}
      inProgress={inProgress}
      schemaType={isBlogArticle ? "BlogPosting" : "Article"}
      pageId={pageId}
      options={customOptions}
    />
  );
};

CMSPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const { blogArticlesData, blogArticleIds } = state.CMSPage || {};
  return { pageAssetsData, inProgress, error, blogArticlesData, blogArticleIds };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CMSPage = compose(
  withRouter,
  connect(mapStateToProps)
)(CMSPageComponent);

export default CMSPage;
